import { AnimationDuration } from "@uno/protocol";
import { AnimationValue } from "../types/Animation";
import { CARD_WIDTH, CARD_HEIGHT } from "../types/Card";
import { getDiscardRotation, measureLayoutRect } from "./utils";
import { getScales } from "utils/CardScale";

const FromRoomPlayerHandToDiscardWithoutRotationAnimation = (playerId: string, index: number, positionInDiscardStack: number): AnimationValue => {
    const scales = getScales();
    const discardScale = scales.discard;
    const discard = document.querySelector("#discard-container");
    const origin = document.querySelector(`[data-player-id="${playerId}"]`);
    const card = origin?.querySelectorAll(".card-container")[index];

    if(!discard || !origin || !card) {
        return { initial: {}, effects: [], transitions: [], duration: 0 };
    }

    const cardEl = card as HTMLElement;
    const firstChild = discard.firstElementChild as HTMLElement;
    const firstChildRect = firstChild
        ? firstChild.getBoundingClientRect()
        : { left: 0, top: 0, width: 0, height: 0 };

    const rotation = getDiscardRotation(positionInDiscardStack);
    const widthCorrection = (CARD_WIDTH * (1 - discardScale)) / 2;
    const heightCorrection = (CARD_HEIGHT * (1 - discardScale)) / 2;

    const { layoutRect, fanTransform: currentTransform } = measureLayoutRect(cardEl);

    const deltaX = (firstChildRect.left - layoutRect.left) / discardScale - widthCorrection;
    const deltaY = (firstChildRect.top - layoutRect.top) / discardScale - heightCorrection;

    return {
        effects: [{
            transformOrigin: ["50% 50%", "50% 50%"],
            scale: [scales.hand, discardScale],
            transform: [
                currentTransform !== "none" ? currentTransform : "translate(0px, 0px)",
                `translate(${deltaX}px, ${deltaY}px) rotate(${rotation}deg)`,
            ],
        }],
        transitions: [{
            duration: AnimationDuration.FromRoomPlayerHandToDiscard,
            fill: "forwards",
            easing: "ease-out",
        }],
        duration: AnimationDuration.FromRoomPlayerHandToDiscard,
    };
};

export default FromRoomPlayerHandToDiscardWithoutRotationAnimation;
